import { render, staticRenderFns } from "./VCostsConnections.vue?vue&type=template&id=7f596ae8&"
import script from "./VCostsConnections.vue?vue&type=script&lang=js&"
export * from "./VCostsConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports